import isEqual from 'lodash/isEqual';
import omitBy from 'lodash/omitBy';
import isUndefined from 'lodash/isUndefined';

export const MAX_SIZE_TITLE = 350;
export const SUGGESTED_SIZE_TITLE = 50;

export const checkIsValid = (errors) => {
  const errorValues = Object.values(errors);
  for (let index = 0; index < errorValues.length; index += 1) {
    if (errorValues[index] !== '') {
      return false;
    }
  }
  return true;
};

export const validateTitle = (value) => {
  let error = '';
  if (!value || value.trim().length === 0) {
    error = 'Title is required';
  }
  if (value && value.length > MAX_SIZE_TITLE) {
    error = 'Number of characters exceeds the available space in the report';
  }
  return error;
};

export const mapDto = ({
  body,
  contentThreadId,
  insight,
  notes,
  sections,
  source,
  tags = [],
  title,
}) =>
  omitBy(
    {
      body,
      contentThreadId,
      insight,
      notes,
      sections,
      source,
      tags: tags.map((tag) => ({
        text: tag,
      })),
      title,
    },
    isUndefined
  );

export const formIsDirty = ({
  title,
  body,
  analysisTitle,
  analysisBody,
  tagsDirty,
  linkedNarrativesChanged,
  initialSections,
  currentSections,
}) => {
  if (title !== analysisTitle) return true;
  if (body !== analysisBody) return true;
  if (linkedNarrativesChanged) return true;
  if (tagsDirty) return true;

  const initialAndCurrentSectionsAreEqual = isEqual(
    initialSections,
    currentSections
  );
  if (!initialAndCurrentSectionsAreEqual) return true;
  return false;
};
